export default "__VITE_ASSET__DZb9YSeC__"